export default {
  id: 142,
  title: 'Target #142 - Curtains',
  url: 'https://cssbattle.dev/play/142',
  colors: ['#4F77FF', '#1038BF', '#FFFFFF'],
  solution:
    '<p a><p b><style>body{background:#4f77ff}p{width:100;height:200;position:fixed;top:34}[a]{width:60;left:50;background:#1038bf;box-shadow:120px 0 #1038bf,240px 0 #1038bf}[b]{width:20;left:130;background:#fff;box-shadow:120px 0 #fff}</style>',
}
